import BaseResource from '@sigmacloud/sigma-client/dist/resources'

export default class SignatureResource extends BaseResource {
  static endpoint = '/signatures'
  static attributes = {
    name: undefined, // Char Field. Max length = 254 characters.
    image_type: 'PNG', // Choice Field. Choices: PNG = (default), SVG, JPEG, NONE.
    base64_blob: undefined, // Text Field containing base 64 encoded signature image data.
    user: undefined, // Foreign Key to User model. Read only.
    ip: undefined, // Char Field of IP address of user who created the signature. Read only.
    created_on: undefined,
    updated_on: undefined
  }
}
